import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('prosic-header'),_c('prosic-time'),_c(VContent,{attrs:{"fluid":""}},[_c('prosic-loader'),_c('prosic-system-status'),_c('prosic-tutorial-init'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{class:{ 'mt-4': _vm.appName.includes('QA') }})],1)],1),_c('prosic-snackbar'),_c('prosic-footer',{attrs:{"app":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }